import Layout from "../components/utils/layout";
import React from "react";

const FloatAnalysis = () => {
    const screenId="FloatAnalysis"
    const charts = {
        float_analysis_forecast : {},
        parent_wallet : {},
        daily_loads: {},
        daily_spend: {},
        shifted_metrics: {},
        for_no_analytics: {},
        peer_transfers_involving_wallet: {
            source: "live"
        },
        peer_transfers_not_involving_wallet: {
            source: "live"
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default FloatAnalysis
